export class UserUpdateDto {
  constructor(
    public role: number,
    public email: string,
    public name: string,
    public lastName: string,
    public phone: string,
    public dni: string
  ) {}
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dto/userUpdate.dto.ts